import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Page Not Found | Lucky Holidays - Premium Travel & Tourism';
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 bg-background-50">
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10 max-w-lg">
        <h1 className="text-xl md:text-3xl font-semibold mt-6 text-foreground-900">Page Not Found</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-foreground-600">
          The page you are looking for does not exist. It might have been moved or deleted.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
        >
          <i className="ri-home-line"></i>
          Back to Home
        </Link>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Page Not Found",
          "description": "The requested page could not be found on Lucky Holidays website.",
          "url": `https://www.luckyholidays.in${location.pathname}`,
          "isPartOf": {
            "@type": "WebSite",
            "name": "Lucky Holidays",
            "url": "https://www.luckyholidays.in/"
          }
        })}
      </script>
    </div>
  );
}